import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-687b541b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics-container" }
const _hoisted_2 = { class: "statistics-container__top" }
const _hoisted_3 = { class: "statistics-container__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccessesStatistics = _resolveComponent("AccessesStatistics")!
  const _component_RankingStatistics = _resolveComponent("RankingStatistics")!
  const _component_GeneralStatistics = _resolveComponent("GeneralStatistics")!
  const _component_TeamStatistics = _resolveComponent("TeamStatistics")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AccessesStatistics),
      (!_ctx.isCirculoTemplate() && _ctx.hasCompany)
        ? (_openBlock(), _createBlock(_component_RankingStatistics, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_GeneralStatistics),
      (!_ctx.isCirculoTemplate() && _ctx.hasCompany)
        ? (_openBlock(), _createBlock(_component_TeamStatistics, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}